import { createAction } from '@reduxjs/toolkit';

export const getReceipt = {
    request: createAction('receipt/get/request'),
    success: createAction('receipt/get/success'),
    failed: createAction('receipt/get/failed'),
};

export const createReceipt = {
    request: createAction('receipt/create/request'),
    success: createAction('receipt/create/success'),
    failed: createAction('receipt/create/failed'),
};

export const updateReceipt = {
    request: createAction('receipt/update/request'),
    success: createAction('receipt/update/success'),
    failed: createAction('receipt/update/failed'),
};

export const deleteReceipt = {
    request: createAction('receipt/delete/request'),
    success: createAction('receipt/delete/success'),
    failed: createAction('receipt/delete/failed'),
};
